// Каркас диалогов настроек: по центру на десктопе (до 440px, длинным спискам — шире через maxWidth), лист снизу на телефоне (BottomSheet, свайп вниз).
// Десктоп — затемнение с blur (в Telegram WebApp без blur); появление — из темы (fade + scale 0.97).
// Телефон — без blur, поверхность карточек, safe-area снизу.
import React from 'react';
import { Box, Dialog } from '@mui/material';
import { CARD_SURFACE_SX } from '../styles/tokens';
import { isTelegramMiniApp } from '../utils/platform';
import { useDesktopLayout } from './layout/AppLayout';
import BottomSheet from './motion/BottomSheet';

export default function ResponsiveDialog({ open, onClose, labelledBy, keyboardInset = 0, maxWidth = 440, children }) {
  const telegram = isTelegramMiniApp();
  const desktop = useDesktopLayout();

  if (!desktop) {
    return (
      <BottomSheet
        open={open}
        onClose={onClose}
        labelledBy={labelledBy}
        paperSx={{
          ...CARD_SURFACE_SX,
          borderRadius: '16px 16px 0 0',
          mb: `${keyboardInset}px`,
          maxHeight: `calc(100% - ${keyboardInset}px - 24px)`,
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overscrollBehavior: 'contain', px: 3, pb: 3 }}>
          {children}
        </Box>
      </BottomSheet>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      aria-labelledby={labelledBy}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0,0,0,0.6)',
          ...(!telegram && { backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)' }),
        },
      }}
      PaperProps={{
        sx: {
          ...CARD_SURFACE_SX,
          color: '#fff',
          width: 'calc(100% - 32px)',
          maxWidth,
          m: 2,
          maxHeight: 'calc(100% - 64px)',
          borderRadius: '16px',
          p: 3,
          overflowY: 'auto',
        },
      }}
    >
      {children}
    </Dialog>
  );
}
